import classNames from 'classnames';

import { useDashboards } from '../../context';
import { WorkbooksByCategoryPair } from '../../models';
import { DashboardsWorkbooksGrid } from '../dashboards-workbooks';

type DashboardsSearchCategoryProps = {
  workbooksByCategory: WorkbooksByCategoryPair[];
};

export const DashboardsSearchCategory = ({
  workbooksByCategory,
}: DashboardsSearchCategoryProps) => {
  const { selectWorkbooksView } = useDashboards();

  return (
    <>
      {workbooksByCategory.map(([category, workbooks], index) => (
        <div
          className={classNames({
            'mb-4': index !== workbooksByCategory.length - 1,
          })}
          key={category}
        >
          <h4 className="p-2 mb-4 border-b border-gray-100">{category}</h4>
          <DashboardsWorkbooksGrid
            onWorkbookSelect={(workbook) =>
              selectWorkbooksView({
                category,
                workbook: workbook.name,
              })
            }
            workbooks={workbooks}
          />
        </div>
      ))}
    </>
  );
};
